module.exports = __webpack_public_path__ + "img/Angiogenesis-OVCA_10X_TIP.00f8cc82.png";